module.exports = __webpack_public_path__ + "img/c726e69.jpg";